import React, { FunctionComponent } from "react";
import { Theme, makeStyles } from "@material-ui/core";
import { ReportBlock } from "./report-block";
import { useTranslation } from "react-i18next";
import { DateTime } from "luxon";
import { DnaReport } from "../../../../../api/smartmelts-api/graphql/generated";
import { GeneticIcon } from "../../../../../assets/icons/user-reports/genetic-icon";

const useStyles = makeStyles((theme: Theme) => ({
  icon: {},
}));

interface IDnaReportBlockProps {
  dnaReport: DnaReport;
}

export const DnaReportBlock: FunctionComponent<IDnaReportBlockProps> = (props) => {
  const classes = useStyles();
  const { dnaReport } = props;
  const { t } = useTranslation();
  const reportDate = dnaReport.reportedAt ? dnaReport.reportedAt : dnaReport.createdAt;
  const reportDateString = DateTime.fromISO(reportDate).toFormat(t("date_format.date"));
  return (
    <ReportBlock
      title={t("user_reports.gene_analysis.result")}
      subtitle={reportDateString}
      leftIcon={<GeneticIcon className={classes.icon} />}
    />
  );
};
